var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-contract-add'},"title":_vm.$t('setting.configuration.contract-template.text')}}),_c('List',{attrs:{"dataList":_vm.templatesList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[],"fields":[ ("contract_type: " + (_vm.$t('setting.configuration.contract-template.type'))),
          ("name: " + (_vm.$t('setting.configuration.contract-template.name')))],"deletes":[_vm.deleted, null],"edit":{link: 'setting-contract-edit'},"filter":{
          search: ['templates.name'],
          dropdown: [{
            title: 'setting.configuration.contract-template.type',
            field: 'templates.contract_type_id',
            data: this.contractTypesList.data,
          }],

        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }